<template>
  <v-dialog v-model="dialog" width="500">
    <template v-slot:activator="{ on }">
      <v-btn
        :outlined="!isBtnActive"
        class="btn-options no-letter-spacing mt-3 mr-2"
        color="primary"
        rounded
        v-on="on"
      >
        <v-icon v-show="isBtnActive" left>check_circle_outline</v-icon>
        {{ title }}
      </v-btn>
    </template>

    <v-card>
      <v-layout>
        <v-flex xs10>
          <v-card-text class="subtitle-1 black--text">{{ title }}</v-card-text>
        </v-flex>
        <v-flex xs2 class="d-flex justify-end">
          <v-btn icon color="primary" class="ma-2" @click="dialog = false">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>

      <v-divider></v-divider>

      <v-layout>
        <v-flex pa-5>
          <template v-if="type === 'checkbox'">
            <v-row v-if="showCheckboxControl">
              <v-col cols="6">
                <v-checkbox
                  color="primary"
                  v-model="checkboxnoneselect"
                  class="mt-0 mb-0"
                  label="ไม่เลือกทั้งหมด"
                  @change="uncheckall"
                ></v-checkbox>
              </v-col>
              <v-col cols="6">
                <v-checkbox
                  color="primary"
                  v-model="checkboxallselect"
                  class="mt-0 mb-0"
                  label="เลือกทั้งหมด"
                  @change="checkall"
                ></v-checkbox>
              </v-col>
              <v-divider></v-divider>
            </v-row>
            <template v-for="(item, index) in dataSource">
              <v-checkbox
                color="primary"
                v-model="selected"
                :key="'cb-' + index"
                :value="item.id"
                :label="item.name"
                hide-details
                class="mt-0 mb-5"
              ></v-checkbox>
            </template>
          </template>
          <template v-else-if="type === 'range'">
            <v-range-slider
              track-color="grey lighten-2"
              v-model="range"
              :max="maxRange"
              :min="minRange"
              hide-details
              class="align-center"
            >
              <template v-slot:prepend>
                <v-text-field
                  hide-details
                  :suffix="label"
                  v-model="range[0]"
                  clearable
                  my-auto
                  solo
                  flat
                  class="card-border"
                  @keypress="onlyNumber($event)"
                />
              </template>
              <template v-slot:append>
                <v-text-field
                  hide-details
                  :suffix="label"
                  v-model="range[1]"
                  clearable
                  my-auto
                  solo
                  flat
                  class="card-border"
                  @keypress="onlyNumber($event)"
                />
              </template>
            </v-range-slider>
          </template>
          <template v-else>
            <v-text-field
              hide-details
              :suffix="label"
              v-model="number"
              clearable
              my-auto
              solo
              flat
              class="card-border"
              @keypress="onlyNumber($event)"
            />
          </template>

          <v-flex xs12 class="mt-8 mb-2 d-flex align-center justify-sm-end flex-column flex-sm-row">
            <v-btn
              :block="$vuetify.breakpoint.xsOnly"
              rounded
              outlined
              width="120"
              color="primary"
              class="mt-2 order-1 order-sm-0"
              @click="cancelClicked"
              >ยกเลิก</v-btn
            >
            <v-btn
              :block="$vuetify.breakpoint.xsOnly"
              rounded
              width="120"
              color="primary"
              class="mt-2 ml-0 ml-sm-2 order-0 order-sm-1"
              @click="confirmClicked"
              >ตกลง</v-btn
            >
          </v-flex>
        </v-flex>
      </v-layout>
    </v-card>
  </v-dialog>
</template>
<script>
import cloneDeep from 'clone-deep';

export default {
  name: 'OptionDialogButton',
  components: {},
  props: {
    value: {
      type: [Number, String, Array]
    },
    title: {
      type: String,
      default: ''
    },
    label: { type: String, default: '' },
    type: {
      type: String,
      default: ''
    },
    dataSource: {
      type: Array,
      default() {
        return [];
      }
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 120
    },
    showCheckboxControl: {
      type: Boolean,
      default: true
    }
  },
  created() {
    this.initValue();
    if (this.type === 'range') this.initRange();
  },
  data: () => ({
    dialog: false,
    selected: [],
    range: [],
    number: '',
    checkboxnoneselect: true,
    checkboxallselect: false
  }),
  mounted() {},
  methods: {
    initValue() {
      switch (this.type) {
        case 'checkbox':
          this.selected = cloneDeep(this.value) || [];
          break;
        case 'range':
          this.range = cloneDeep(this.value) || cloneDeep([this.minRange, this.maxRange]);
          this.range[0] = this.range[0] || this.minRange;
          this.range[1] = this.range[1] || this.maxRange;
          break;
        case 'number':
          this.number = this.value || '';
          break;
        default:
          this.number = this.value || '';
      }
    },
    initRange() {
      this.range[0] = cloneDeep(this.minRange);
      this.range[1] = cloneDeep(this.maxRange);
    },
    numberWithTwoDecimal($event, num) {
      // console.log($event);
      // console.log($event.keyCode); //keyCodes value
      const keyCode = $event.keyCode ? $event.keyCode : $event.which;

      // only allow number and one dot
      if ((keyCode < 48 || keyCode > 57) && (keyCode !== 46 || num.indexOf('.') !== -1)) {
        // 46 is dot
        $event.preventDefault();
      }

      // restrict to 2 decimal places
      if (num != null && num.indexOf('.') > -1 && num.split('.')[1].length > 1) {
        $event.preventDefault();
      }
    },
    onlyNumber($event) {
      const keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    cancelClicked() {
      this.closeDialog();
      this.initValue();
    },
    confirmClicked() {
      this.closeDialog();
      this.saveData();
    },
    closeDialog() {
      this.dialog = false;
    },
    saveData() {
      let data;
      if (this.type === 'checkbox') {
        data = cloneDeep(this.selected);
        if (data.length === 0) {
          this.removeKey();
          return;
        }
      } else if (this.type === 'range') {
        data = cloneDeep(this.range);
        data[0] = data[0] === this.min ? null : data[0];
        data[1] = data[1] === this.max ? null : data[1];
        if (data.every(x => x === null)) {
          this.removeKey();
          return;
        }
      } else {
        data = this.number;
        // console.log(data);
        if (data === '' || data === null) {
          this.removeKey();
          return;
        }
      }
      this.$emit('input', data);
    },
    removeKey() {
      this.$emit('remove-key');
    },
    checkall() {
      this.checkboxnoneselect = false;
      this.selected = [];
      for (let index = 0; index < this.dataSource.length; index++) {
        const element = this.dataSource[index];
        this.selected.push(element.id);
      }
    },
    uncheckall() {
      this.checkboxallselect = false;
      this.selected = [];
    }
  },
  computed: {
    minRange() {
      if (this.min !== undefined) {
        return this.min;
      }
      return 0;
    },
    maxRange() {
      if (this.max !== undefined) {
        return this.max;
      }
      return 0;
    },
    isBtnActive() {
      if (this.value !== undefined) {
        switch (this.type) {
          case 'checkbox':
            return this.value.length > 0;
          case 'range':
            // console.log(this.value);
            // console.log(
            //   (this.value[0] > this.minRange || this.value[1] < this.maxRange) &&
            //     this.value[1] !== null &&
            //     this.value[1] !== 0
            // );
            return this.value[0] !== null || this.value[1] !== null;
          case 'number':
            return this.value !== '' && this.value !== null;
          default:
            return false;
        }
      }
      return false;
    }
  },
  watch: {
    value(val) {
      this.initValue();
      // console.log(val);
    },
    selected() {
      if (this.selected.length == this.dataSource.length) this.checkboxallselect = true;
      else this.checkboxallselect = false;
      if (this.selected.length == 0) this.checkboxnoneselect = true;
      else this.checkboxnoneselect = false;
    }
  }
};
</script>
<style lang="scss" scoped>
button.btn-options {
  height: inherit !important;
  min-height: 36px;
}

::v-deep .v-btn__content {
  width: 100%;
  white-space: normal;
}
</style>
